/**
 * Pop up blocker for Chrome - Poper Blocker
 *
 * Patches XMLHttpRequest and window.open, injects a promo UI root, and leaves three
 * globals in the main world. Observed on version 8.7.4.
 */
import { probeSelector, probeGlobal } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bkkbcggnhapdmkeljlodobbkopceiche';
export const poperBlocker: ExtensionDefinition = {
  id: ID,
  name: 'Pop up blocker for Chrome™ - Poper Blocker',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2_000_000,
  notes: 'Patches window.open and XHR, and injects its own promotional UI into pages.',
  signals: [
    { id: 'global-betterjspop', kind: 'global',
      description: 'Check for window.BetterJsPop, its main-world popup interception shim.',
      weight: 1, run: () => probeGlobal('BetterJsPop') },
    { id: 'global-external-command', kind: 'global',
      description: 'Check for window.pbExternalCommand — the "pb" prefix is Poper Blocker\'s own namespace.',
      weight: 1, run: () => probeGlobal('pbExternalCommand') },
    { id: 'dom-promo-root', kind: 'dom',
      description: 'Look for #pb-feature-promo-root, the injected promotional UI container.',
      weight: 0.5, run: () => probeSelector('#pb-feature-promo-root', { timeoutMs: 1200 }) },
  ],
};
